var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", {
    staticClass: "chromecast-manager",
    class: _vm.videoPlayerStoreState.castAvailable ? "available" : "",
    domProps: {
      innerHTML: _vm._s(
        "<button is='google-cast-button' class='vs-btn-legacy'></button>"
      )
    }
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }